/**
 * Google Identity Services (02.10.2026): Anmeldung im Google-Fenster von CreatorOffice selbst statt über die Supabase-Adresse
 * (sonst zeigt Google „Weiter zu qyzytbsptcmyjttyqkgf.supabase.co“). Google liefert ein ID-Token; der Anmeldedienst prüft es
 * mit der Klartext-Nonce (signInWithIdToken), Google bekommt nur deren SHA-256. Voraussetzung: VITE_GOOGLE_CLIENT_ID aus dem
 * Build und https://app.creatoroffice.de als autorisierter JavaScript-Ursprung im OAuth-Client. Ohne beides bleibt die Umleitung.
 */
interface GsiId {
  initialize(opts: Record<string, unknown>): void;
  renderButton(el: HTMLElement, opts: Record<string, unknown>): void;
}
declare global {
  interface Window { google?: { accounts?: { id?: GsiId } } }
}

export function googleClientId(): string | null {
  const id = (import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined)?.trim();
  return id && /^[0-9]+-[a-z0-9]+\.apps\.googleusercontent\.com$/.test(id) ? id : null;
}

let laden: Promise<GsiId> | null = null;
export function gsiLaden(): Promise<GsiId> {
  laden ??= new Promise<GsiId>((resolve, reject) => {
    if (window.google?.accounts?.id) { resolve(window.google.accounts.id); return; }
    const s = document.createElement("script");
    s.src = "https://accounts.google.com/gsi/client";
    s.async = true;
    s.onload = () => (window.google?.accounts?.id ? resolve(window.google.accounts.id) : reject(new Error("gsi")));
    s.onerror = () => { laden = null; reject(new Error("gsi")); };
    document.head.appendChild(s);
  });
  return laden;
}

/** Zufällige Nonce und ihr SHA-256 (hex), wie Google und der Anmeldedienst sie erwarten */
export async function nonceErzeugen(): Promise<{ roh: string; hash: string }> {
  const bytes = crypto.getRandomValues(new Uint8Array(24));
  const roh = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(roh));
  return { roh, hash: Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, "0")).join("") };
}
